module.exports = __webpack_public_path__ + "assets/img/itemHeaderBk2.d86ac7f8.png";